module.exports = __webpack_public_path__ + "img/frxxbg1.66215bf4.png";